import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'inspect-appointment');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'providers',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['providerUserId'],
    },
    'patients',
    {
      type: 'payload',
      selector: ['patientUserId'],
    },
    'appointments',
    'form_inspections',
  ],
});

export default createReqReducer(consts);
// POST /api/providers/:provider_user_id/patients/:patient_user_id/appointments/form_inspections



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/appointment-inspector-req.js